// family based configuration
const familyConfig = {
	default: {
		skipConfigurationEngine: false,
		defaultProductFamily: '',
		forceOverview: false
	},
	TheLine: {
		skipConfigurationEngine: false,
		defaultProductFamily: 'TheLine',
		forceOverview: false
	},

	LightProfile: {
		skipConfigurationEngine: true,
		defaultProductFamily: '',
		forceOverview: false,
	},
	Aeto: {
		skipConfigurationEngine: false,
		defaultProductFamily: 'Aeto',
		forceOverview: false,
		maintenance: true
	},

	Avanza: {
		skipConfigurationEngine: false,
		defaultProductFamily: 'Avanza',
		forceOverview: true
	},
	Lanova: {
		skipConfigurationEngine: false,
		defaultProductFamily: 'Lanova',
		forceOverview: true
	},
	Tal: {
		skipConfigurationEngine: false,
		defaultProductFamily: 'Tal',
		forceOverview: true
	},
	Saturn: {
		skipConfigurationEngine: false,
		defaultProductFamily: 'Saturn',
		forceOverview: true
	},
	Aya: {
		skipConfigurationEngine: false,
		defaultProductFamily: 'Aya',
		forceOverview: true
	},
	Yloo: {
		skipConfigurationEngine: false,
		defaultProductFamily: 'Yloo',
		forceOverview: true
	},
	Aira: {
		skipConfigurationEngine: false,
		defaultProductFamily: 'Aira',
		forceOverview: true
	},
	Alpha: {
		skipConfigurationEngine: false,
		defaultProductFamily: 'Alpha',
		forceOverview: true
	},
	Anatar: {
		skipConfigurationEngine: false,
		defaultProductFamily: 'Anatar',
		forceOverview: true
	},
	Arca: {
		skipConfigurationEngine: false,
		defaultProductFamily: 'Arca',
		forceOverview: true
	},
	Astro: {
		skipConfigurationEngine: false,
		defaultProductFamily: 'Astro',
		forceOverview: true
	},
	Axeo: {
		skipConfigurationEngine: false,
		defaultProductFamily: 'Axeo',
		forceOverview: true
	},
	Beta: {
		skipConfigurationEngine: false,
		defaultProductFamily: 'Beta',
		forceOverview: true
	},
	Discera: {
		skipConfigurationEngine: false,
		defaultProductFamily: 'Discera',
		forceOverview: true
	},
	Elo: {
		skipConfigurationEngine: false,
		defaultProductFamily: 'Elo',
		forceOverview: true
	},
	Inula: {
		skipConfigurationEngine: false,
		defaultProductFamily: 'Inula',
		forceOverview: true
	},
	Jessica: {
		skipConfigurationEngine: false,
		defaultProductFamily: 'Jessica',
		forceOverview: true
	},
	Lif: {
		skipConfigurationEngine: false,
		defaultProductFamily: 'Lif',
		forceOverview: true
	},
	Lukida: {
		skipConfigurationEngine: false,
		defaultProductFamily: 'Lukida',
		forceOverview: true
	},
	Mistella: {
		skipConfigurationEngine: false,
		defaultProductFamily: 'Mistella',
		forceOverview: true
	},
	Olivio: {
		skipConfigurationEngine: false,
		defaultProductFamily: 'Olivio',
		forceOverview: true
	},
	Rondero: {
		skipConfigurationEngine: false,
		defaultProductFamily: 'Rondero',
		forceOverview: true
	},
	Sombreo: {
		skipConfigurationEngine: false,
		defaultProductFamily: 'Sombreo',
		forceOverview: true
	},
	Tessia: {
		skipConfigurationEngine: false,
		defaultProductFamily: 'Tessia',
		forceOverview: true
	},
	Trigo: {
		skipConfigurationEngine: false,
		defaultProductFamily: 'Trigo',
		forceOverview: true
	},
	Valetta: {
		skipConfigurationEngine: false,
		defaultProductFamily: 'Valetta',
		forceOverview: true
	},
	Start: {
		skipConfigurationEngine: true,
		defaultProductFamily: '',
		forceOverview: true
	},
};

export function getFamilyConfig(family) {
	return familyConfig[family] ?? familyConfig.default;
}

export default familyConfig;
